import { ApolloClient, createHttpLink, InMemoryCache, makeVar } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { PODCAST_LS_TOKEN, UserMenu } from "./constants";

const token = localStorage.getItem(PODCAST_LS_TOKEN);
export const isLoggedInVar = makeVar(Boolean(token));
export const authTokenVar = makeVar(token);
export const userMenuVar = makeVar(UserMenu.Home);
export const curEpisodeVar = makeVar({
  title: "",
  podcastId: -1,
  fileUrl: "",
  volume: 50,
});

const httpLink = createHttpLink({
  uri: process.env.NODE_ENV === "production" ? "https://pocast-backend.herokuapp.com/graphql" : "http://localhost:4000/graphql",
});

const authLink = setContext((_, { headers }) => {
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      "X-JWT": authTokenVar() || "",
    },
  };
});

export const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          isLoggedIn: {
            read() {
              return isLoggedInVar();
            },
          },
          token: {
            read() {
              return authTokenVar();
            },
          },
          userMenu: {
            read() {
              return userMenuVar();
            },
          },
          curEpisode: {
            read() {
              return curEpisodeVar();
            },
          },
        },
      },
    },
  }),
});
